<div class="content">
    <div class="row">
        <h3 mat-dialog-title style="font-size: 24px;">Alert: CFPB RESPA Triggered</h3>
        <div class="Vert-15"></div>
    </div>
    
    <mat-dialog-content>
       <p>This application now has the six pieces of information required to trigger a Loan Estimate within three business days.</p>

       <ul>
            <li>A - Address of the subject property</li>
            <li>L - Loan amount requested</li>
            <li>I - Income of applicant</li>
            <li>E - Estimated value of mortgage loan application</li>
            <li>N – Names of borrowers</li>
            <li>S – Social Security Number</li>
       </ul>

       <p>You can continue editing the application and submit it when complete. If you exit or remain inactive for over 15 minutes, the current version will be submitted.
            Deleting any of these six pieces won't undo RESPA disclosure.</p>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-button class="btn btn-primary"
            (click)="dialogRef.close({action:true})">OK</button>
    </div>
</div>
